<template>
  <v-card :loading="loading" elevation="2" outlined>
    <v-card-title>
      <v-btn
        v-status="'category_create'"
        class="btn-add-with-text ma-0"
        to="/category/create"
      >
        <v-icon>mdi-plus</v-icon>
        افزودن دسته بندی
      </v-btn>
    </v-card-title>

    <v-divider class="mx-4 mt-0" />

    <v-row class="pa-2" no-gutters>
      <v-col class="pa-2" cols="12" lg="3" md="4" sm="6">
        <v-select
          v-model="tableProps.length"
          :items="[10, 25, 50, 100, 200, 400]"
          :menu-props="{ offsetY: true }"
          clear-icon="mdi-close-circle-outline"
          clearable
          dense
          hide-details
          label="تعداد نمایش"
          outlined
          @change="reloadTable()"
        />
      </v-col>

      <v-col class="pa-2" cols="12" lg="3" md="4" sm="6">
        <v-select
          v-model="tableProps.service_id"
          :items="services"
          :menu-props="{ offsetY: true }"
          clear-icon="mdi-close-circle-outline"
          clearable
          dense
          hide-details
          item-text="nameLand"
          item-value="id"
          label="انتخاب سرویس"
          outlined
          @change="reloadTable()"
        />
      </v-col>

      <v-col class="pa-2" cols="12" lg="3" md="4" sm="6">
        <v-text-field
          v-model="tableProps.search"
          append-icon="mdi-magnify"
          clear-icon="mdi-close-circle-outline"
          clearable
          dense
          hide-details
          label="جستجو"
          outlined
          @keydown.enter="reloadTable()"
          @click:append="reloadTable()"
          @click:clear="clearFilter"
        />
      </v-col>

      <v-col class="pa-2" cols="12" lg="3" md="4" sm="6">
        <v-select
          v-model="tableProps.status"
          :items="statusItems"
          :menu-props="{ offsetY: true }"
          clearable
          dense
          hide-details
          label="وضعیت نمایش"
          outlined
          @change="reloadTable()"
          @click:clear="clearFilter"
        />
      </v-col>

      <v-col class="pa-2" cols="12">
        <data-table :columns="columns" :data="data" :translate="translate">
          <div slot="filters" />

          <div slot="pagination">
            <pagination
              v-if="data && data.data"
              ref="pagination"
              :data="data"
              @page="onPagination"
            >
              <template v-slot:per-page>
                <v-select
                  v-model="tableProps.length"
                  :items="[10, 25, 50, 100, 400]"
                  :menu-props="{ offsetY: true }"
                  class="ma-2 my-md-0"
                  dense
                  label="تعداد نمایش"
                  outlined
                  @change="onPerPage"
                />
              </template>
            </pagination>
          </div>
        </data-table>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import CategoryPicker from "./categoryPicker";
import Btn from "./Btn";
import Button from "@/view/pages/Button";
import { SET_BREADCRUMB } from "../../../core/services/store/breadcrumbs.module";
import Pagination from "../pickers/pagination";

export default {
  components: {
    Pagination,
    CategoryPicker,
  },
  data() {
    return {
      services: [],
      data: {},
      loading: false,
      url: "category/get-all",
      translate: {
        nextButton: "بعدی",
        previousButton: "قبلی",
        rowsPerPageText: "تعداد در صفحه",
        noDataText: "داده ای برای نمایش وجود ندارد",
        placeholderSearch: "جستجو",
      },
      tableProps: {
        search: "",
        length: 10,
        column: "id",
        dir: "desc",
        service_id: "",
        page: 1,
      },
      columns: [
        {
          label: "شناسه",
          name: "id",
          orderable: true,
          colStyle: "width: 100px;",
        },
        {
          label: "نام",
          name: "name",
          orderable: true,
        },
        {
          label: "آدرس",
          name: "slug",
          transform: (value, data) => {
            return value.data.slug == null
              ? '<p class="text-danger">ندارد</p>'
              : value.data.slug;
          },
          orderable: true,
        },
        {
          label: "زیرمجموع",
          name: "parent",
          transform: (value, data) => {
            return !value.data.parent
              ? '<p class="text-danger">ندارد</p>'
              : value.data.parent.name;
          },
        },

        {
          label: "نوع سرویس",
          name: "service",
          transform: (val) => {
            return this.$options.filters.serviceType(val.data.service.nameLand);
          },
        },
        {
          label: "وضعیت نمایش",
          name: "status",
          orderable: true,
          transform: (value, data) => {
            return value.data.status ? "فعال" : "غیر فعال";
          },
        },
        {
          label: " سربرگ",
          name: "special",
          orderable: true,
          transform: (value, data) => {
            return value.data.special ? "بله" : "خیر";
          },
        },
        {
          label: "تاریخ ویرایش",
          name: "updated_at",
          orderable: true,
          transform: (val) => {
            return this.$options.filters.longDate(val.data.updated_at);
          },
        },

        {
          name: "actions",
          label: "عملیات",
          component: Button,
          handler: this.actions,
          event: "action",
          meta: {
            permission_prefix: "category_",
            buttons: [
              {
                name: "edit",
                label: "ویرایش",
                icon: "pencil-alt",
                class: "btn-edit",
              },
              {
                name: "delete",
                label: "حذف",
                icon: "trash",
                class: "btn-delete",
              },
            ],
          },
        },

        // {
        //   label: 'عملیات',
        //   name: 'actions',
        //   component: Btn,
        //   handler: this.action,
        //   event: 'action',
        //   meta: {
        //     permission_prefix: 'category_',
        //   }
        //
        // },
      ],
      statusItems: [
        { value: 1, text: "نمایش" },
        { value: 0, text: "عدم نمایش" },
        { value: 2, text: "غیرفعال" },
      ],
    };
  },

  created() {
    this.getServices();
    this.getData(this.url);
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: this.$t(this.$route.meta.title) },
    ]);
  },

  methods: {
    getData(url = this.url, options = { ...this.tableProps }) {
      this.loading = true;

      if (options.hasOwnProperty("status") && options.status === 2) {
        options.disabled = 1;
        delete options.status;
      }

      this.requestApiGet(this.url, options)
        .then((response) => {
          this.data = response.data;
        })
        .finally(() => (this.loading = false));
    },
    getServices() {
      this.requestApiGet("getServices").then(({ data }) => {
        this.services = data.services;
      });
    },
    reloadTable(tableProps) {
      this.tableProps.page = 1;
      this.$nextTick(() => {
        this.getData(this.url, tableProps);
      });
    },
    clearFilter() {
      this.$nextTick(() => {
        this.reloadTable();
      });
    },
    onPagination(e) {
      if (e !== this.page) {
        this.tableProps.page = e;
        this.$nextTick(() => {
          this.getData();
          window.scrollTo({ behavior: "smooth", top: 0, left: 0 });
        });
      }
    },
    onPerPage() {
      this.$refs.pagination.last_emit = 1;
      window.scrollTo({ behavior: "smooth", top: 0, left: 0 });
    },
    reloadTable1(tableProps) {
      this.getData(this.url, tableProps);
    },
    actions(data, type) {
      this[type](data);
    },
    delete(data) {
      this.$can();
      this.$swal({
        text: "آیا از حذف این دسته بندی اطمینان دارید؟",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "بله",
        cancelButtonText: "خیر",
        reverseButtons: true,
        confirmButtonClass: "btn btn-danger",
        cancelButtonClass: "btn btn-secondary",
        buttonsStyling: false,
      }).then((result) => {
        if (result.isConfirmed) {
          this.requestApiDelete(`categories/${data.id}`).then((response) => {
            this.reloadTable(this.tableProps);
            this.$toast.success("دسته بندی با موفقیت حذف شد");
          });
        }
      });
    },
    edit(data) {
      this.$router.push({ name: "category.edit", params: { id: data.id } });
    },
  },
};
</script>

<style></style>
